import {withLocalization} from '@epic-core/localization';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import ClientDownloadDropDown from '../../components/download/ClientDownloadDropDown';

import DownloadSelectionWrapper from './DownloadSelectionWrapper';

/**
 * That you for downloading, with option to select another platform.
 */
class DownloadSelection extends React.Component {
  static propTypes = {
    mobileStore: PropTypes.object.isRequired,
    section: PropTypes.object.isRequired,
    appConfigStore: PropTypes.object.isRequired,
    playerStore: PropTypes.object.isRequired,
    footerStore: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool,
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    messages: PropTypes.object.isRequired,
  };

  render() {
    const {
      messages,
      appConfigStore,
      playerStore,
      mobileStore: {
        androidMobileData: {hideDownload, createAccount},
      },
      isLoggedIn,
      section,
      history,
      match,
      mobileStore,
    } = this.props;

    const headerStyle = {};
    const backgroundStyle = {};
    const {align, data, downloadThankYouText} = section;
    const legalTagsColor = (data && data.legalTagsColor) || '';
    const availableColor = (data && data.availableColor) || '';

    if (data) {
      if (data.backgroundColor) {
        backgroundStyle.backgroundColor = data.backgroundColor;
      }
      if (data.fontColor) {
        backgroundStyle.color = data.fontColor;
      }
      if (data.headerFontColor) {
        headerStyle.color = data.headerFontColor;
      }
    }

    const legalTags = this.props.footerStore.config.legalTags || [];
    const disableAndroid = hideDownload && createAccount;
    //add ios back into supportedOS array
    let supportedOS = ['windows', 'mac', 'android', 'xbl', 'psn', 'nintendo'];
    if (disableAndroid) {
      supportedOS = ['windows', 'mac', 'xbl', 'psn', 'nintendo'];
    }
    const containerClass = classNames('LPdownloadSelection');
    const textClass = classNames('default', align || 'center');
    return (
      <div className={containerClass}>
        <DownloadSelectionWrapper
          desktopSrc={data.background?.desktopImage}
          mobileSrc={data.background?.mobileImage}
          tabletSrc={data.background?.tabletImage}>
          <div className="LPdlwrapper-lowlight-overlay" />
          <ClientDownloadDropDown
            headerStyle={headerStyle}
            supportedOS={supportedOS}
            align={align}
            data={data}
            downloadThankYouText={downloadThankYouText}
            className={textClass}
            messages={messages}
            appConfigStore={appConfigStore}
            playerStore={playerStore}
            mobileStore={mobileStore}
            isLoggedIn={isLoggedIn}
            history={history}
            match={match}
            legalTags={legalTags}
            legalTagsColor={legalTagsColor}
            availableColor={availableColor}
          />
        </DownloadSelectionWrapper>

        {data.copyright && (
          <div className="copyright">
            <p>{data.copyright}</p>
          </div>
        )}
      </div>
    );
  }
}

export default withLocalization(DownloadSelection);
